"use strict";

var KeyboardUtil = {
  keys: {
    enter: "Enter"
  }
};

module.exports = KeyboardUtil;


//////////////////
// WEBPACK FOOTER
// ./~/reactjs-components/lib/Util/KeyboardUtil.js
// module id = 1305
// module chunks = 2